import React from 'react';
import { Modal } from 'react-responsive-modal';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { buy } from 'redux/actions/exchange';
import { spinDice } from 'redux/actions/user';
import './index.scss';

const ModalName = 'ModalConfirm';

const Exchange = ({ renderButtonOk, renderButtonNo }) => {
	const dispatch = useDispatch();
	const { selected, localize } = useSelector(
		(state) => ({
			selected: state.exchange.selectedItem,
			localize: state.localize.event,
		}),
		shallowEqual
	);
	const text = localize?.txt_exchange_desc.split('[[token]]');
	return (
		<>
			<p className="text">
				{text[0]}
				<img
					alt=""
					className="diamond"
					src={process.env.REACT_APP_CDN_URL + 'ico_info_exchange_token.png'}
				/>
				<b style={{ margin: '0 .05rem' }}>{selected?.price}</b> {text[1]}
			</p>
			<div className="item">
				<div className={`item-img item-img-${selected?.id}`}>
					<img alt="" src={selected?.image} />
					<span className="item-count">x{selected?.count}</span>
				</div>
			</div>
			<div className="group">
				{renderButtonNo()}
				{renderButtonOk(() => dispatch(buy(selected)))}
			</div>
		</>
	);
};

const Spin = ({ renderButtonOk, renderButtonNo }) => {
	const dispatch = useDispatch();
	const { price, localize } = useSelector(
		(state) => ({
			price: state.game.spinPrice,
			localize: state.localize.event,
		}),
		shallowEqual
	);
	const text = localize?.txt_spin_desc.split('[[token]]');
	return (
		<>
			<p className="text">
				{text[0]}
				<img
					alt=""
					className="diamond"
					src={process.env.REACT_APP_CDN_URL + 'ico_info_spin_token.png'}
				/>
				<b style={{ margin: '0 .05rem' }}>{price}</b> {text[1]}
			</p>
			<div className="group">
				{renderButtonNo()}
				{renderButtonOk(() => dispatch(spinDice()))}
			</div>
		</>
	);
};

const Confirm = ({ name, toggleModal }) => {
	const closeModal = () => toggleModal(ModalName);
	const { type, localize } = useSelector(
		(state) => ({
			type: state.main.confirmType,
			localize: state.localize.event,
		}),
		shallowEqual
	);
	const components = {
		exchange: Exchange,
		spin: Spin,
	};
	const CurrentComponent = components[type];
	return (
		<Modal
			open={name[ModalName]}
			classNames={{
				modal: `modal modal-confirm`,
				overlay: 'overlay',
				closeButton: 'close-button',
				closeIcon: 'close-icon',
				modalAnimationIn: 'slideInUp',
				modalAnimationOut: 'slideOutDown',
			}}
			animationDuration={250}
			center
			focusTrapped={false}
			showCloseIcon={false}
			closeOnOverlayClick={false}
			onClose={closeModal}
			blockScroll={false}
		>
			<div className="modal-title">
				<h3>{localize?.txt_confirm_title}</h3>
			</div>
			<div className="modal-content">
				<CurrentComponent
					renderButtonNo={() => (
						<button
							onClick={closeModal}
							className="btn btn-no"
							type="button"
							aria-label="Cancel"
						>
							{localize?.txt_cancel}
						</button>
					)}
					renderButtonOk={(onClick) => (
						<button
							onClick={onClick}
							className="btn btn-ok"
							type="button"
							aria-label="Yes"
						>
							{localize?.txt_yes}
						</button>
					)}
				/>
			</div>
		</Modal>
	);
};

export default Confirm;
